import { createFileRoute } from '@tanstack/react-router';
import { fundingListSearchSchema } from '@/pages/ai-matching-results/lib/fundingListSearchSchema';
import { SpecialAllocationTaxSurveyPage } from '@/pages/ai-matching-results/ui/SpecialAllocationTaxSurveyPage';

export const Route = createFileRoute(
  '/_protected/projects/ai-matching-results/special-allocation-tax-survey/',
)({
  component: SpecialAllocationTaxSurveyPage,
  validateSearch: (search) => fundingListSearchSchema.parse(search),
});
